<template>
    <template v-if="!small && cartStore.hasProduct(product.id)">
        <div class="d-flex align-items-center">
            <span
                v-if="showTrash"
                class="btn btn-outline-primary btn-lg me-2"
                @click.prevent="cartStore.remove(product.id); $emit('update-quantity', 1)"
            >
                <img class="size-18 has-dark" src="@img/icons/delete.svg" alt="remove" />
            </span>
            <div class="flex-grow-1">
                <QuantityInput :product="product" @update-quantity="updateQuantity"/>
            </div>
        </div>
    </template>
    <template v-else>
        <span
            :class="`btn btn-primary btn-${size} w-100`"
            @click.stop.prevent="cartStore.storeUpdateSave(
    product.id,
    product.order_quantity_step || 1,
    route.name.startsWith('checkout-')
  )"
        >
            {{ $t('products.add_to_cart') }}
        </span>
    </template>
</template>

<script setup>
import { useCartStore } from '~/stores/CartStore'
const QuantityInput = defineAsyncComponent(() => import('../QuantityInput.vue'))

const cartStore = useCartStore();
const route = useRoute();
</script>

<script>
import QuantityStepMixin from '~/mixins/QuantityStepMixin'
import { useProductQuantityStore } from '~/stores/ProductQuantityStore'

export default {
    mixins: [QuantityStepMixin],
    emits: ['update-quantity'],
    props: {
        product: {
            required: true,
            type: Object
        },
        icon: Boolean,
        size: {
            default: 'lg',
            type: String
        },
        small: {
            type: Boolean,
            default: false
        },
        showTrash: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        quantityStep() {
            return this.product.order_quantity_step || 1
        }
    },
    methods: {
        updateQuantity(quantity) {
            // quantity += useCartStore().getProductQuantity(this.product.id)
            quantity = this.adjustQuantity(quantity, this.quantityStep)
            useCartStore().updateCart(this.product.id, quantity)
            useProductQuantityStore().setQuantity(this.product.id, quantity)
            this.$emit('update-quantity', quantity);
        },
    }
}
</script>
